import './App.css';
import Sidebar from './Sidebar';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useCookies } from 'react-cookie';
import './Main.css';
import { FaMapMarkerAlt, FaMicrosoft, FaBed, FaCarAlt, FaHome, FaCheckCircle, FaCloudUploadAlt } from "react-icons/fa";
import { useParams, useHistory } from 'react-router-dom';
import Background from './Background';
import { useState, useEffect, useCallback } from 'react';
import './TableStyle.css';
import { MapContainer, TileLayer } from 'react-leaflet';
import {useDropzone} from 'react-dropzone';
import { ToastContainer, toast } from 'react-toastify';
import React from 'react';
import { t } from 'i18next';
import { useTranslation } from 'react-i18next';

function AddCareer() {

    const [cookies, setCookie] = useCookies(['user']);
    const inputRef = React.createRef();
    const [title,setTitle] = useState("");
    const [description,setDescription] = useState("");
    const [company,setCompany] = useState("");
    const [lastDateToApply,setLastDateToApply] = useState("");
    const [experience,setExperience] = useState("");
    const [type,setType] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const { t, i18n } = useTranslation();

    const addCareerAPI = () => {
        var data = new FormData();
        if(title == "") {
            toast(t("enter_title"));
        } else if(description == "") {
            toast(t("enter_description"));
        } else if(experience == "") {
            toast(t("enter_experience"));
        } else if(type == "") {
            toast(t("enter_type"));
        } else {
            data.append("title",title);
            data.append("description",description);
            if(company) data.append("company",company);
            if(lastDateToApply) data.append("last_date_to_apply",lastDateToApply);
            data.append("experience",experience);
            data.append("type",type);
            data.append("user_id", cookies.id ?? '');
            setIsLoading(true);
            fetch('https://api.connecker.com/api/add_career', {
                method: 'POST',
                body: data
            }).then(res => {
                setIsLoading(false);
                if(!res.ok) {
                    throw Error('Could not fetch');
                }
                return res.json();
            }).then(async(data) => {
                setIsLoading(false);
                if(data.response_code == 200) {
                    toast(data.message);
                } else if(data.response_code == 404) {
                    toast(data.message);
                } else {
                    toast(data.message);
                }
            });
        }
    }

    return(
        <div className="content">
            <div className="row d-flex justify-content-center">
                <div className="col-2 col-sm-2">
                    <Sidebar></Sidebar>
                </div>
                <div className="col-10 col-sm-10" style={{ paddingLeft: "40px" }}>
                    <Background></Background>
                    <h4 style={{ color:"white", marginTop:"50px" }}>{t("add_career")}</h4>
                    <div class="card" style={{width:"100%"}}>
                        <div class="card-body">
                            <div className="d-flex">
                                <h6 style={{ color:"orange" }}>{t("basic")}</h6>
                                &nbsp;
                                <h6>{t("information")}</h6>
                            </div>
                            <br></br>
                            <div className="row g-3">
                                <div className="col-md-6">
                                    <label className="form-label" style={{ fontSize: "13px", color: "#666" }}>{t("title")}</label>
                                    <input type="text" className="form-control" style={{ border:"1px solid lightgrey", borderRadius:"8px", padding:"10px" }} onChange={(e) => setTitle(e.target.value)} placeholder={t("title")} />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label" style={{ fontSize: "13px", color: "#666" }}>{t("company") || "Company"}</label>
                                    <input type="text" className="form-control" style={{ border:"1px solid lightgrey", borderRadius:"8px", padding:"10px" }} onChange={(e) => setCompany(e.target.value)} placeholder={t("company") || "Company"} />
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label" style={{ fontSize: "13px", color: "#666" }}>{t("last_date_to_apply") || "Last date to apply"}</label>
                                    <input type="date" className="form-control" style={{ border:"1px solid lightgrey", borderRadius:"8px", padding:"10px" }} onChange={(e) => setLastDateToApply(e.target.value)} />
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label" style={{ fontSize: "13px", color: "#666" }}>{t("experience")}</label>
                                    <input type="text" className="form-control" style={{ border:"1px solid lightgrey", borderRadius:"8px", padding:"10px" }} onChange={(e) => setExperience(e.target.value)} placeholder={t("experience")} />
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label" style={{ fontSize: "13px", color: "#666" }}>{t("type")}</label>
                                    <input type="text" className="form-control" style={{ border:"1px solid lightgrey", borderRadius:"8px", padding:"10px" }} onChange={(e) => setType(e.target.value)} placeholder={t("type")} />
                                </div>
                                <div className="col-12">
                                    <label className="form-label" style={{ fontSize: "13px", color: "#666" }}>{t("description")}</label>
                                    <textarea rows={6} className="form-control" style={{ border:"1px solid lightgrey", borderRadius:"8px", padding:"10px" }} onChange={(e) => setDescription(e.target.value)} placeholder={t("description")} />
                                </div>
                                <div className="col-12">
                                    <button onClick={() => addCareerAPI()} style={{ color:"white", backgroundColor:"#FF4500", border:"1px solid #FF4500", borderRadius:"8px", padding:"10px 32px" }}>{t("submit")}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </div>
    );
}

export default AddCareer;